import React, { Component } from "react";

import styles from "./style.module.scss";

import Title from "../Title";
import DropdownSection from "../DropdownSection";
import { TweenLite, TimelineLite } from "gsap";

import pdf1 from "./gdpr-partneri.pdf";
import pdf2 from "./gdpr-reality.pdf";
import pdf3 from "./gdpr-consulting.pdf";
import pdf4 from "./gdpr-spolfin.pdf";

import pdf5 from "./vlpartneri.pdf";
import pdf6 from "./vlreality.pdf";
import pdf7 from "./vlconsultingoffice.pdf";

class Footer extends Component {
    state = {};

    gdprRef = React.createRef();
    infoRef = React.createRef();
    leftLineRef1 = React.createRef();
    leftLineRef2 = React.createRef();
    rightLineRef1 = React.createRef();
    rightLineRef2 = React.createRef();

    toggleInfo = (infoRef, leftLineRef, rightLineRef, id) => {
        if (this.state.info) {
            this.close(infoRef, leftLineRef, rightLineRef);
            this.setState({ info: false });
        } else {
            this.open(infoRef, leftLineRef, rightLineRef, id);
            this.setState({ info: true });
        }
    };
    toggleGdpr = (infoRef, leftLineRef, rightLineRef, id) => {
        if (this.state.gdpr) {
            this.close(infoRef, leftLineRef, rightLineRef);
            this.setState({ gdpr: false });
        } else {
            this.open(infoRef, leftLineRef, rightLineRef, id);
            this.setState({ gdpr: true });
        }
    };
    open = (infoRef, leftLineRef, rightLineRef, id) => {
        const tl = new TimelineLite();
        TweenLite.to(leftLineRef.current, 0.3, {
            delay: 0.5,
            rotation: -45,
        });
        TweenLite.to(rightLineRef.current, 0.3, {
            delay: 0.5,
            rotation: 45,
        });

        tl.set(infoRef.current, {
            height: "auto",
            autoAlpha: 1,
            onComplete: () => {
                this.height = infoRef.current.getBoundingClientRect().height;
            },
        }).set(infoRef.current, {
            autoAlpha: 0,
            height: 0,
            onComplete: () =>
                TweenLite.to(infoRef.current, 0.3, {
                    autoAlpha: 1,
                    height: this.height,
                    onComplete: () => this.scrollTo(id),
                }),
        });
    };
    close = (infoRef, leftLineRef, rightLineRef) => {
        TweenLite.to(leftLineRef.current, 0.3, {
            delay: 0.5,
            rotation: 45,
        });
        TweenLite.to(rightLineRef.current, 0.3, {
            delay: 0.5,
            rotation: -45,
        });
        TweenLite.to(infoRef.current, 0.3, {
            autoAlpha: 0,
            height: 0,
        });
    };

    scrollTo = (id) => {
        TweenLite.to(window, 0.3, {
            delay: 0.2,
            scrollTo: { y: id, offsetY: -90, autoKill: false },
        });
    };

    render() {
        return (
            <div className={styles.footer}>
                <Title
                    white
                    noMargin
                    id="informace"
                    text="Informace pro spotřebitele"
                />
                <DropdownSection subtitle="Informace o zpracování osobních údajů">
                    <div className={styles.rubric}>
                        <div className={styles.info}>
                            Informace o zpracování osobních údajů klientů
                            VL&Partneři s.r.o. najdete{" "}
                            <span
                                onClick={() => window.open(pdf1)}
                                className={styles.link}
                            >
                                zde
                            </span>
                            .
                        </div>
                        <div className={styles.info}>
                            Informace o zpracování osobních údajů klientů VL
                            Reality s.r.o. najdete{" "}
                            <span
                                onClick={() => window.open(pdf2)}
                                className={styles.link}
                            >
                                zde
                            </span>
                            .
                        </div>
                        <div className={styles.info}>
                            Informace o zpracování osobních údajů klientů VL
                            Consulting Office s.r.o. najdete{" "}
                            <span
                                onClick={() => window.open(pdf3)}
                                className={styles.link}
                            >
                                zde
                            </span>
                            .
                        </div>
                        <div className={styles.info}>
                            Informace o zpracování osobních údajů klientů
                            Společnost finančních služeb s.r.o. najdete{" "}
                            <span
                                onClick={() => window.open(pdf4)}
                                className={styles.link}
                            >
                                zde
                            </span>
                            .
                        </div>
                    </div>
                </DropdownSection>

                <DropdownSection subtitle="Pojištění">
                    <div className={styles.rubric}>
                        <div className={styles.info}>
                            Informace o pojištění společnosti VL&Partneři s.r.o.
                            najdete{" "}
                            <span
                                onClick={() => window.open(pdf5)}
                                className={styles.link}
                            >
                                zde
                            </span>
                            .
                        </div>
                        <div className={styles.info}>
                            Informace o pojištění společnosti VL Reality s.r.o.
                            najdete{" "}
                            <span
                                onClick={() => window.open(pdf6)}
                                className={styles.link}
                            >
                                zde
                            </span>
                            .
                        </div>
                        <div className={styles.info}>
                            Informace o pojištění společnosti VL Consulting
                            Office s.r.o. najdete{" "}
                            <span
                                onClick={() => window.open(pdf7)}
                                className={styles.link}
                            >
                                zde
                            </span>
                            .
                        </div>
                        {/* <div className={styles.info}>
                            Informace o pojištění společnosti Financial Office
                            s.r.o. najdete{" "}
                            <span
                                onClick={() => window.open(pdf8)}
                                className={styles.link}
                            >
                                zde
                            </span>
                            .
                        </div> */}
                    </div>
                </DropdownSection>

                <DropdownSection subtitle="Informace o zprostředkovatelské činnosti">
                    <div className={styles.rubric}>
                       Zprostředkováváme pojištění, úvěry, doplňkové penzijní spoření a investice jako vázaný zástupce společnosti Broker Trust, a.s.,
                       která je vedena v registru ČNB jako samostatný a investiční zprostředkovatel IČO: 26439719.
                       I my jsme registrovaní v registru ČNB, jako vázaný zástupce, a to pod IČO: 04122801,
                       Společnost finančních služeb s.r.o., Fuchsova 1016/26, 602 00 Brno.
                        <br />
                        <br />
                        <div id="scroll" className={styles.more}>
                            Více informací najdete na: {" "}
                            <a
                                href="https://www.brokertrust.cz/pro-klienty"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.link}
                            >
                                https://www.brokertrust.cz/pro-klienty
                            </a>
                        </div>
                    </div>
                </DropdownSection>
            </div>
        );
    }
}

export default Footer;
